"use client";

import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCollectionStoreProps } from "./C3IKGW5T.js";
import { useStore, useStoreProps } from "./YV4JVR4I.js";
import { useId } from "./ABQUS43J.js";
import { __spreadValues } from "./3YLGPPWQ.js"; // src/composite/composite-store.ts

import * as Core from "@ariakit/core/composite/composite-store";

function useCompositeStoreOptions(props) {
  var id = useId(props.id);
  return __spreadValues({
    id: id
  }, props);
}

function useCompositeStoreProps(store, update, props) {
  store = useCollectionStoreProps(store, update, props);
  useStoreProps(store, props, "activeId", "setActiveId");
  useStoreProps(store, props, "includesBaseElement");
  useStoreProps(store, props, "virtualFocus");
  useStoreProps(store, props, "orientation");
  useStoreProps(store, props, "rtl");
  useStoreProps(store, props, "focusLoop");
  useStoreProps(store, props, "focusWrap");
  useStoreProps(store, props, "focusShift");
  return store;
}

function useCompositeStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  props = useCompositeStoreOptions(props);

  var _useStore = useStore(Core.createCompositeStore, props),
      _useStore2 = _slicedToArray(_useStore, 2),
      store = _useStore2[0],
      update = _useStore2[1];

  return useCompositeStoreProps(store, update, props);
}

export { useCompositeStoreOptions, useCompositeStoreProps, useCompositeStore };